import { IStyleConfig, mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './FatPanel.css';

export interface IFatPanelProps {
  title?: string;
  description?: string;
  iconUrl?: string;
  containerStyles?: IStyleConfig;
  isHidden?: boolean;
  type?: 'big' | 'normal';
}

export function FatPanel({ title, description, iconUrl, containerStyles, isHidden, type = 'normal' }: IFatPanelProps) {
  if (isHidden || (!title && !description && !iconUrl)) {
    return null;
  }

  return (
    <div {...mergeStyles(styles['container'], type === 'big' && styles['container--big'], containerStyles)}>
      <div className={styles['icon_container']}>
        <img src={iconUrl} alt={title} />
      </div>
      <div className={styles['main_container']}>
        <strong className={styles['title']}>{title}</strong>
        <p className={styles['description']}>{description}</p>
      </div>
    </div>
  );
}
